import HowItWorks from "@/components/waylio/HowItWorks";

export default function HowWeWorkPage() {
  return (
    <main className="pt-10 md:pt-12">
      <HowItWorks />
    </main>
  );
}
